/// <reference types="@angular/localize" />

// DEBUG: Intercept ALL cookie writes to find who deletes accessToken
(function() {
  const originalDescriptor = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie') ||
                             Object.getOwnPropertyDescriptor(HTMLDocument.prototype, 'cookie');
  if (originalDescriptor && originalDescriptor.set) {
    const originalSet = originalDescriptor.set;
    Object.defineProperty(document, 'cookie', {
      get: function() { return originalDescriptor.get!.call(this); },
      set: function(value: string) {
        if (value.includes('accessToken')) {
          const isDeleting = value.includes('accessToken=;') || value.includes('accessToken=\u0000') || value.includes('expires=Thu, 01 Jan 1970');
          const isEmpty = value.match(/accessToken=($|;)/);
          if (isDeleting || isEmpty) {
            console.error('[COOKIE TRAP] accessToken being DELETED via document.cookie! Value:', value, 'Stack:', new Error().stack);
          } else {
            console.log('[COOKIE TRAP] accessToken being SET. Value length:', value.length);
          }
        }
        return originalSet.call(this, value);
      },
      configurable: true
    });
  }
})();

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { ModuleRegistry } from 'ag-charts-community';
import { AllCommunityModule } from 'ag-charts-community';
import Axios from 'axios';

ModuleRegistry.registerModules(AllCommunityModule);
import { environment } from './environments/environments';
import { AxiosRequestInterceptor } from './app/shared/http/interceptors/axios-request-interceptor';
import { AxiosResponseErrorInterceptor, AxiosResponseInterceptor } from './app/shared/http/interceptors/axios-response-interceptor';
import axios, { AxiosHeaders, InternalAxiosRequestConfig } from "axios"
Axios.defaults.baseURL = environment.baseUrl;
Axios.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  config.headers = AxiosHeaders.from(config.headers);
  const token = localStorage.getItem("token");
  console.log('[AXIOS-REQ]', config.method?.toUpperCase(), config.url, '| localStorage token present:', !!token, '| Authorization header already set:', !!config.headers.get('Authorization'));
  if (token) config.headers.set("Authorization", `Bearer ${token}`);

  return config;
});
Axios.interceptors.response.use(
  (response) => {
    console.log('[AXIOS-RES] OK', response.status, response.config.url);
    return AxiosResponseInterceptor(response);
  },
  (error) => {
    console.error('[AXIOS-RES] ERROR', error.response?.status, error.config?.url, error.message);
    return AxiosResponseErrorInterceptor(error);
  }
);
platformBrowserDynamic().bootstrapModule(AppModule, {
  ngZoneEventCoalescing: true
})
  .catch(err => console.error(err));

